import create from 'zustand';

interface DrawerState {
  isOpen: boolean;
  controlId?: string; // optional control id
  openDrawer: (controlId?: string) => void;
  closeDrawer: () => void;
  toggleDrawer: () => void;
}

const useDrawerStore = create<DrawerState>((set) => ({
  isOpen: false,
  controlId: undefined,
  openDrawer: (controlId: string | undefined) =>
    set({ isOpen: true, controlId }),
  closeDrawer: () => set({ isOpen: false, controlId: undefined }),
  toggleDrawer: () => set((state) => ({ isOpen: !state.isOpen })),
}));

export default useDrawerStore;
